import { graphql, useStaticQuery } from "gatsby";

const filesQuery = graphql`
  query {
    allFile(filter: { relativeDirectory: { eq: "pages/home" } }) {
      edges {
        node {
          publicURL
          name
          ext
        }
      }
    }
  }
`;

const useHomePageFiles = (filename) => {
  const { allFile } = useStaticQuery(filesQuery);
  if (!filename) return null;
  const edge = allFile.edges.find(
    (e) => `${e?.node?.name}${e?.node?.ext}` === filename
  );
  if (edge) return edge?.node?.publicURL;
  return null;
};

export default useHomePageFiles;
